export default class HttpError extends Error {
	constructor(
		readonly response: Response,
		message?: string,
		options?: ErrorOptions
	) {
		super(message, options);
	}
}
